import React, { PropTypes } from 'react';
import { LocaleService } from '@sm360/widget-commons-core-services';
import { Account } from '@sm360/widget-commons-general';
import { ValidationService } from '@sm360/widget-commons-forms';

import AddressSection from 'deposit/components/AddressSection/AddressSection.jsx';
import config from 'deposit/config/index.js';
import CatchPhrase from 'deposit/components/CatchPhrase/CatchPhrase.jsx';
import CreditCard from 'deposit/components/CreditCard/CreditCard.jsx';
import IndentitySection from 'deposit/components/IndentitySection/IndentitySection.jsx';

import 'deposit/components/DepositForm/DepositForm.scss';

import ERRORS from 'deposit/constants/errors.js';

class DepositForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            contact: {
                ...props.account,
                phoneNumber: props.account.homePhone,
                email: props.account.email1,
            },
            cardInfo: {
                cardNumber: '',
                cvc: '',
                expiringYear: '',
                expiringMonth: '',
            },
            formValidation: {},
            errors: [],
            isButtonDisable: true,
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleFormGroupChange = this.handleFormGroupChange.bind(this);
    }

    handleSubmit(event) {
        event.preventDefault();
    }

    handleFormGroupChange(groupResponse) {
        const nexState = this.state;
        const isValid = groupResponse.valid;
        const { value, name } = groupResponse;

        nexState.formValidation[name] = isValid;

        if (name === 'identityGroup' || name === 'addressGroup') {
            nexState.contact = { ...this.state.contact, ...value };
            nexState.contact.email1 = value.email || nexState.contact.email1;
            nexState.contact.homePhone = value.phoneNumber || nexState.contact.homePhone;
            nexState.contact.address = value.address || nexState.contact.address;
            nexState.contact.address2 = value.address2 || nexState.contact.address2;
            nexState.contact.city = value.city || nexState.contact.city;
            nexState.contact.postalCode = value.postalCode || nexState.contact.postalCode;
            nexState.contact.province = value.province || nexState.contact.province;
        } else {
            nexState.cardInfo = { ...nexState.cardInfo, ...value };
        }

        if (isValid) {
            const errorIndex = nexState.errors.findIndex((error) => {
                return error.group === name;
            });

            if (errorIndex !== -1) {
                nexState.errors.splice(errorIndex, 1);
            }
        } else {
            const createError =
                nexState.errors.findIndex((error) => {
                    return error.group === name;
                }) === -1;

            if (createError) {
                nexState.errors.push({
                    code: groupResponse.error.code,
                    group: name,
                    message: LocaleService.t(ERRORS[groupResponse.error.code]),
                });
            }
        }

        this.setState({
            ...nexState,
            isButtonDisable: !ValidationService.validateForm(nexState.formValidation),
        });
    }

    render() {
        const imagesServer = config.source.image;
        const { buttonConf } = this.props;
        const buttonClasses = ['sr-button-1 is-small'];
        const buttonIcon = buttonConf.icon && <icon className={buttonConf.icon} />;
        const errorMessage =
            this.props.hasError && this.props.errorMessage.length > 0
                ? this.props.errorMessage.map((message) => {
                      return message.message;
                  })
                : [];
        const errorMessageDisplay = (
            <p className="error-forms" dangerouslySetInnerHTML={{ __html: errorMessage.join('<br/>') }} />
        );

        return (
            <form onSubmit={this.handleSubmit}>
                <div className="deposit__inner-content has-primary-background">
                    <IndentitySection
                        contactValue={this.state.contact}
                        hasBeenSubmit={this.props.hasBeenSubmit}
                        handleFormGroupChange={this.handleFormGroupChange}
                    />

                    <AddressSection
                        contactValue={this.state.contact}
                        hasBeenSubmit={this.props.hasBeenSubmit}
                        handleFormGroupChange={this.handleFormGroupChange}
                    />

                    <hr />

                    <section className="deposit__credit-card-container">
                        <h1 className="sr-title-1">{LocaleService.t('DEPOSIT.DEPOSIT_TITLE')}</h1>
                        <CatchPhrase depositAmount={this.props.depositAmount} />
                        <img
                            src={`${imagesServer}/images/widget/showroom/asset/credit-cards.png`}
                            alt={LocaleService.t('DEPOSIT.PAYMENT_INFOS_SECTION.IMG_ALT')}
                        />
                        <CreditCard
                            onChange={this.handleFormGroupChange}
                            cardInfo={this.state.cardInfo}
                            errors={this.state.errors}
                            depositAmount={this.props.depositAmount}
                            hasBeenSubmit={this.props.hasBeenSubmit}
                        />
                    </section>
                </div>

                <div>
                    <div className="deposit-next-btn-section">
                        {errorMessageDisplay}
                        <button
                            type="button"
                            className={buttonClasses.join(' ')}
                            onClick={() => this.props.onClick(this.state)}
                        >
                            {buttonConf.label}
                            {buttonIcon}
                        </button>
                    </div>
                </div>
            </form>
        );
    }
}

DepositForm.defaultProps = {
    hasError: false,
    hasBeenSubmit: false,
    errorMessage: '',
};

DepositForm.propTypes = {
    account: PropTypes.instanceOf(Account).isRequired,
    onClick: PropTypes.func.isRequired,
    buttonConf: PropTypes.shape({
        label: PropTypes.string,
        icon: PropTypes.string,
    }).isRequired,
    depositAmount: PropTypes.number.isRequired,
    hasError: PropTypes.bool,
    hasBeenSubmit: PropTypes.bool,
    errorMessage: PropTypes.string,
};

DepositForm.displayName = 'DepositForm';

export default DepositForm;



// WEBPACK FOOTER //
// ./src/components/DepositForm/DepositForm.jsx